<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Historial de ingresos" }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui encontraras el historial de todos tus ingresos realizados." }}</div>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col class="d-flex pl-0 py-0">
          <div style="width: 286px;">
            <v-autocomplete
              label="Selecciona un usuario"
              :items="users"
              hide-details
              style="font-family: 'montserrat-medium'; border-radius: 20px;"
              outlined
              clearable
              class="mr-2"
              item-value="sCustomerEnterpriseId"
              item-text="sName"
              @change="getIncomes()"
              v-model="selectedUser"
            ></v-autocomplete>
          </div>
          <div style="width: 286px;">
            <v-autocomplete
              :label="'Selecciona una currency'"
              :items="currencies"
              hide-details
              style="font-family: 'montserrat-medium'; border-radius: 20px;"
              outlined
              class="mr-2"
              color="black"
              item-value="sValue"
              item-text="sName"
              @change="getIncomes()"
              v-model="selectedCurrency"
            ></v-autocomplete>
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#000000" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :items="items" >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left" >{{ "Usuario" }}</th>     
              <th class="header__title center">{{ "Payer name" }}</th>                                                                                                                                                                                    
              <th class="header__title center">{{ "Fecha de ingreso" }}</th>
              <th class="header__title right">{{ "Monto ingresado" }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.CustomerEnterprises }}</td>
              <td class="table__item">{{ item.sPayerName ? item.sPayerName : "-" }}</td>
              <td class="table__item">{{ formatDate(item.created_at) }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " " + item.sCurrency }}</td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items" >
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ "Usuario" }}</div>
                <div>{{ item.CustomerEnterprises }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Payer name" }}</div>
                <div>{{ item.sPayerName ? item.sPayerName : "-" }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de ingreso" }}</div>
                <div>{{ formatDate(item.created_at) }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto ingresado" }}</div>
                <div>{{ "$ " + formatMoney(item.dAmount) + " USD" }}</div>
              </td>
            </tr>
            <v-divider></v-divider>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

export default {
  name: "IncomesView",
  data() {
    return {
      nameXLSX: "HistorialIngresos.xlsx",
      users: [],
      selectedUser: "",
      isLoading: false,
      items: [],
      selectedCurrency: "USD",
      currencies: [
        { sName: "USD", sValue: "USD" },
        { sName: "MXN", sValue: "MXN" },
      ],
    };
  },
  methods: {
    getUsers() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/en/administrator/users`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.users = response.data.results
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.data.code) {
          this.$router.push("/welcome").catch(() => {});
        }
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    getIncomes() {
      this.isLoading = true;

      const payload = {
        sEnterpriseId: this.selectedUser,
        currency: this.selectedCurrency
      };

      DB.post(`${URI}/api/v1/en/administrator/incomes`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.items = response.data.incomes
        this.isLoading = false;
      }).catch((error) => {
          // this.isLoading = false;
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM D, YYYY");
      return formattedDate;
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Id: item.iTrackingId ? item.iTrackingId : "",
            "Usuario": item.CustomerEnterprises ? item.CustomerEnterprises : "",
            "Fecha de ingreso": item.created_at ? this.formatDate(item.created_at) : "",
            "Nombre del pagador": item.sPayerName ? item.sPayerName : "",
            "Monto": item.dAmount ? parseFloat(item.dAmount) : "",
            "Moneda": item.sCurrency ? item.sCurrency : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
  },
  beforeMount() {
    this.getIncomes();
    this.getUsers();
  },
};
</script>

<style>
</style>
